import React from 'react';
import ReactMarkdown from 'react-markdown';

const LessonPlanScreen = ({ lessonPlanText }) => (
  // console.log('LessonPlanScreen rendered', lessonPlanText),
  <div style={{ padding: 16, background: '#fff' }}>
    <ReactMarkdown>{lessonPlanText}</ReactMarkdown>
  </div>
);

export default LessonPlanScreen;